/**
 *  @class
 *  @function ViewProducts
 */
if (!customElements.get('view-products')) {
  class ViewProducts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.querySelector(this.dataset.target);
      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener() {
      document.body.classList.add('open-cc');
      this.drawer.classList.add('active');
    }
  }
  customElements.define('view-products', ViewProducts);
}

document.addEventListener('DOMContentLoaded', () => {
  const toggleViewProductsButtons = document.querySelectorAll('.stl-cta-button');

  toggleViewProductsButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const drawer = button.closest('.gallery__item').querySelector('.view-products');
      drawer.click();
    });
  });

  // gallery__item-clickable 
  const galleryItems = document.querySelectorAll('.gallery__item-clickable');

  galleryItems.forEach((item) => {
    item.addEventListener('click', (e) => {
      const viewProducts = item.querySelector('.view-products');
      viewProducts.click();
    });
  });

});
